<template>
    <div class="games-container">
        <div id="games" class="container pt-5">


            <div class="d-flex flex-column w-md-75 justify-content-center mx-auto text-center my-md-5">
                <h2>Joacă-te împreună cu Tuti</h2>

                <p class="pt-3">La Academia Spațială Dr. Leahu vii pregătit de distracție, pentru că aici te așteaptă
                    experiențe memorabile și jocuri haioase, deștepte și pline de acțiune.</p>
            </div>

            <div class="d-flex flex-row flex-wrap justify-content-between">

                <div v-for="(game, index) in games" v-bind:key="index"
                     class="custom-width-games my-auto mx-auto px-2 text-center ">
                    <button type="button" data-toggle="modal" data-target="#games-modal"
                            @click="selectGame(game)">
                        <img :src="game.logo" alt="" class="img-fluid">
                    </button>
                </div>

                <div v-if="this.selectedGame">
                    <games-modal
                            :selected="this.selectedGame"></games-modal>
                </div>


            </div>



        </div>

    </div>

</template>

<script>
    import GamesModal from "./GamesModal.vue"

    export default {
        components: {
            GamesModal
        },
        name: "Games",
        data() {
            return {
                games: [
                    {
                        id: 1,
                        name: 'aerodintica',
                        logo: require('../../assets/imgs/games/logo-super-tuti.png'),
                        description: 'Un joc plin de acțiune în care trebuie să îl ajuți pe Tuti, Dințișorul Zurliu să navigheze printre acadele gigantice.',
                        howToPlay: 'Că să controlezi ghiozdanul cu reacție, apasă pe ecran atunci când vrei ca Tuti să urce și ia degetul de pe ecran dacă vrei să coboare. Folosește această metodă că să treci cu bine de obstacole și să nu te lovești de acadelele care îți blochează drumul.',
                    },
                    {
                        id: 2,
                        name: 'colorpop',
                        logo: require('../../assets/imgs/games/logo-colorpop.png'),
                        description: 'Un joc în care trebuie să îl aperi pe Tuti, Dințișorul Zurliu înainte să se strângă prea multe bomboane și să ajungă la el.',
                        howToPlay: 'Trage în grupuri de bomboane din linie care au aceeași culoare, că să le spargi până să îl atingă pe Tuti. Ține minte: trei sau mai multe bomboane de aceeași culoare explodează. Dacă poți exploda mai multe culori în același timp, primești bonusuri, iar unele bomboane au chiar puteri speciale care te ajută.',
                    },
                    {
                        id: 3,
                        name: 'combonele',
                        logo: require('../../assets/imgs/games/logo-combonele.png'),
                        description: 'Un joc isteț în care trebuie să scapi de bombonele aranjându-le în linii de același fel.',
                        howToPlay: 'Că să faci să dispară bomboanele, mută-le între ele astfel încât să se așeze în linie cel puțin trei de același fel. Când aliniezi mai multe culori în același timp, obții combouri și primești puncte în plus. Nu poți mișca obstacolele, deci încearcă să potrivești bomboanele in jurul lor dacă poți. Alege cu atenție, pentru că ai un număr limitat de mutări.',
                    },
                    {
                        id: 4,
                        name: 'dintica-ratacica',
                        logo: require('../../assets/imgs/games/logo-zurlica-ratacica.png'),
                        description: 'Un joc de atenție care îți cere să îl cauți pe Tuti, Dințișorul Zurliu prin peisaj și să îl găsești înainte să se scurgă timpul.',
                        howToPlay: 'Că să îl găsești pe Tuti, privește peisajul cu atenție și pune degetul oriunde îl vezi. Tuti apare de mai multe ori în fiecare peisaj. Uneori este aproape, alteori este departe, în spate. Uneori se vede cu totul, alteori doar o părticică. Uită-te cu atenție și îl vei găsi cu siguranță.',
                    },
                    {
                        id: 5,
                        name: 'meteorix',
                        logo: require('../../assets/imgs/games/logo-meteorix.png'),
                        description: 'Un joc în care trebuie să îl ajuți pe Tuti, Dințișorul Zurliu în drumul lui spre Zana Măseluță ghidându-i nava printre asteroizi și adunând stele.',
                        howToPlay: 'Că să câștigi trebuie să reușești să ferești nava spațială a lui Tuti de pericolele din câmpul de asteroizi că să poți adună cât mai multe stele pe drum. Oricând treci printr-un portal, nava se colorează că să te avertizeze că asteroizii de aceeași culoare te pot lovi. Prea multe lovituri îți vor distruge nava, deci ai grijă la asteroizii de aceeași culoare cu nava ta!',
                    },
                    {
                        id: 6,
                        name: 'ricobon',
                        logo: require('../../assets/imgs/games/logo-ricobon.png'),
                        description: 'Un joc de acțiune care te provoacă să distrugi toate bombonelele prea dulci în timp ce ferești dințișorii de vrăjitoarea care vrea să îi carieze.',
                        howToPlay: 'Că să câștigi trebuie să muți periuță în stânga și în dreapta că să lovești bila și să o trimiți către bomboane până le distrugi pe toate. Încearcă să prinzi balonașele care îți dau bonusuri speciale. Și prinde Dulciurica înainte să ajungă la dințișorii de jos.',
                    },
                    {
                        id: 7,
                        name: 'exploratron',
                        logo: require('../../assets/imgs/games/logo-exploratron.png'),
                        description: 'O experiență cum nu ai mai văzut! Un loc inovator unde poți să te plimbi cu nava spațială prin cosmos sau, dacă preferi distracția mai aproape de Pământ, descoperi dacă poți să sari până ajungi la nori.',
                        howToPlay: 'Suntem mândri de acest spațiu minunat pe care l-am creat. E așa diferit încât trebuie să îl vezi cu ochii tăi! Și nu doar cu ochii, trebuie să îl simți cu tot corpul, pentru că exact așa îl controlezi: intri cu totul și sari, ridici mâinile, te apleci și te învârți — și vezi cum mișcările tale au efect asupra acțiunii.',
                    }

                ],
                selectedGame: null
            }
        },
        methods: {
            selectGame(game) {
                this.selectedGame = game;
            }
        }
    }
</script>

<style scoped>

</style>
